import { useEffect, useState } from "react";
import FullPage from "../elements/fullPage/fullPage.jsx";
import { useIntl, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import * as action from "../../reduxStore/actions/phonebook";
import { PHONEBOOK_ENTRIES } from "../../reduxStore/actions/main";

import classes from "./phonebook.module.scss";
import { CampusSelection } from "../elements/campusSelection/campusSelection.component";
import { includeText } from "../search/search.jsx";
import Highlight from "../elements/text/highlight.text.jsx";
import ToastsContainer from "../elements/toast/toasts.container";
import * as settingsAction from "../../reduxStore/actions/settings";
import StandardCard from "../elements/cards/StandardCard.card.jsx";
import RoundedIcon from "../elements/buttons/roundedIcon.component.jsx";
import StandardHeadline from "../elements/text/standardHeadline.text.jsx";
import { statisticLogger } from "../statisticLogger/StatisticLogger.container.js";
import { pageNames } from "../../reduxStore/reducers/main.js";
import { getCampusNameById } from "../../functions/helper/helpers.functions.js";

let isFuzzy = false;

function Phonebook(props) {
  const intl = useIntl();
  const [filterCampusIds, setFilterCampusIds] = useState([props.campusId]);
  const [limit, setLimit] = useState(50);
  const [searchText, setSearchText] = useState("");
  const [favourites, setFavourites] = useState([]);
  const [phonebookEntries, setPhonebookEntries] = useState([]);

  const setSetting = () => {
    const setting = {
      filter: {
        ...props.settings,
        phonebook: {
          ...props.settings.phonebook,
          campusId: !filterCampusIds.length ? 0 : filterCampusIds[0],
        },
      },
    };
    props.setProperties(setting);
  };
  const resetFilterCampus = () => {
    setFilterCampusIds([]);
  };
  const toggleFavorites = (id) => {
    props.favorites.includes(id)
      ? props.removeFromFavourite(id)
      : props.addToFavourite(id);
  };
  const toggleFilterCampus = (id) => {
    setFilterCampusIds(
      filterCampusIds.includes(id)
        ? filterCampusIds.filter((i) => i !== id)
        : [id]
    );
  };
  const getRelevantPhonebookEntries = (fuzzy) => {
    isFuzzy = fuzzy;
    if (searchText === "") return PHONEBOOK_ENTRIES;
    return PHONEBOOK_ENTRIES.filter(
      (pe) =>
        (!filterCampusIds.length || filterCampusIds.includes(pe.campusId)) &&
        !("" !== searchText && !includeText(pe, fuzzy, searchText))
    ).map((pe) => ({
      ...pe,
      name: pe.name.toLowerCase().includes(searchText.toLowerCase())
        ? pe.name
        : `${pe.name} (${pe.includesSearchString(searchText)})`.replace(
            "(undefined)",
            ""
          ), //wenn die fuzzysearch anschlägt. anonsten hätte hier noch eine prüfung hingemusst und das wollte ich dem code nicht antun.
    }));
  };
  const filterRelevantEntries = () => {
    let phonebookEntries = getRelevantPhonebookEntries(false);

    if (!phonebookEntries.length) {
      phonebookEntries = getRelevantPhonebookEntries(true);
    }

    const phonebookEntriesFiltered = phonebookEntries.filter((element) => {
      return (
        (filterCampusIds && filterCampusIds[0] == undefined) ||
        filterCampusIds.includes(element.campusId)
      );
    });

    setPhonebookEntries(phonebookEntriesFiltered);
  };
  const filterFavourites = () => {
    const favourites = phonebookEntries.filter((entry) =>
      props.favorites.includes(entry.id)
    );
    setFavourites(favourites);
  };

  useEffect(() => {
    statisticLogger.currentPage = pageNames.phonebook;
    statisticLogger.addLog({
      action: {
        id: "enterPhonebookPage",
        name: "Enter Phonebook Page",
        group: "Page",
        movement: "enter",
        type: "click",
      },
    });
  }, []);

  useEffect(setSetting, [filterCampusIds]);

  useEffect(filterRelevantEntries, [searchText, filterCampusIds]);

  useEffect(filterFavourites, [phonebookEntries]);

  return (
    <FullPage
      title={intl.formatMessage({ id: "phonebook.title" })}
      searchText={searchText}
      setSearchText={setSearchText}
      innerContainerClassName={"pb-half"}
      bgClass="ca-bg-light"
      userHasScrolledToBottom={(isTrue) =>
        isTrue ? setLimit(limit + 50) : null
      }
    >
      <ToastsContainer />
      {!PHONEBOOK_ENTRIES.length ? (
        <h2>
          <FormattedMessage id="phonebook.empty" />
        </h2>
      ) : (
        <>
          <CampusSelection
            toggle={toggleFilterCampus}
            reset={resetFilterCampus}
            selectedCampuses={filterCampusIds}
          />
          <h3>
            {!phonebookEntries.length ? (
              <FormattedMessage
                id="search.fuzzySearchCategories"
                values={{ searchText }}
              />
            ) : isFuzzy ? (
              <FormattedMessage
                id="search.onlyFuzzySearch"
                values={{ searchText }}
              />
            ) : null}
          </h3>
          {favourites.length ? (
            <>
              <h4 className={classes.primaryTitle}>
                <FormattedMessage id="phonebook.savedNumbers" />
              </h4>
              {favourites.map((item) => (
                <PhoneCard
                  key={item.id}
                  id={item.id}
                  description={item.description}
                  name={item.name}
                  phone={item.phone}
                  searchText={searchText}
                  favorites={props.favorites}
                  toggleFavorites={toggleFavorites}
                />
              ))}
            </>
          ) : null}
          <h4
            className={`${
              !props.favorites.length
                ? classes.primaryTitle
                : classes.secondaryTitle
            }`}
          >
            <FormattedMessage id="phonebook.unsavedNumbers" />
          </h4>
          {phonebookEntries.slice(0, limit).map((item) => {
            return (
              <PhoneCard
                key={item.id}
                id={item.id}
                description={item.description}
                name={item.name}
                phone={item.phone}
                searchText={searchText}
                favorites={props.favorites}
                toggleFavorites={toggleFavorites}
                campusId={item.campusId}
              />
            );
          })}
        </>
      )}
    </FullPage>
  );
}
export const PhoneCard = ({
  favorites,
  searchText,
  toggleFavorites,
  name,
  id,
  phone,
  description,
  campusId,
}) => {
  return (
    <StandardCard className={`mb-3 standardCard--phone`}>
      <div className="d-flex align-items-center">
        <StandardHeadline
          type={"h3"}
          className={"mr-3"}
          text={<Highlight search={searchText}>{name}</Highlight>}
        />
        <div className={"d-flex ml-auto"}>
          <RoundedIcon
            onClick={() => toggleFavorites(id)}
            iconClass={`${
              favorites.includes(id)
                ? "roundedIcon--favorite--isFavorite__icon"
                : ""
            }`}
            divClass={`mr-2 roundedIcon--favorite ${
              favorites.includes(id) ? "roundedIcon--favorite--isFavorite" : ""
            }`}
            icon={["fal", "star"]}
          />
          <RoundedIcon
            icon={["fal", "phone"]}
            divClass={"roundedIcon--primary"}
            iconClass={"roundedIcon--primary__icon"}
            onClick={() => {
              window.location = `tel:${phone.replace(/[^0-9]/g, "")}`;
            }}
          />
        </div>
      </div>
      <p>{phone}</p>
      <p>{description}</p>
      {campusId && (
        <div className="d-flex justify-content-between">
          <span className="overflow-auto">{getCampusNameById(campusId)}</span>
        </div>
      )}
    </StandardCard>
  );
};

const mapStateToProps = (state) => {
  return {
    favorites: state.phonebook.favorites,
    campusId: state.settings.filter.phonebook.campusId,
    audience: state.settings.event,
    settings: state.settings.filter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToFavourite: (id) => dispatch(action.addToFavourite(id)),
    removeFromFavourite: (id) => dispatch(action.removeFromFavourite(id)),
    setProperties: (properties) =>
      dispatch(settingsAction.setProperties(properties)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Phonebook);
